import React, {Component} from 'react';
import translate from '../../services/translation';

export default class LoadingSpinner extends Component {


	render() {

		return (
			<span>
				{translate('pagination.load')}
			</span>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Favourites/LoadingSpinner.js